import React from 'react'

const RightsholderContactListContentHeader = () => (
    <>
        <p>
            Per regulatory requirements, song owners must make some contact information available in the Public Work
            Search. To protect your privacy, The MLC has added three different “contact types” that allow you to
            designate specific contact information for different uses.{' '}
            <strong> Please note that only first name and email are required.</strong>
        </p>
        <p>
            For full information about public database contact types, click&nbsp;
            <a href="https://help.themlc.com/en/support/contact-types">here.</a>
        </p>
    </>
)

export default RightsholderContactListContentHeader
